// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.bwPerson-name[data-v-1f36753f]{font-weight:700}.bwPerson-products[data-v-1f36753f]{margin-top:10px}.bwPerson__price[data-v-1f36753f]{margin-right:25px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
